RivalIQ.apps.AdsInsights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    function isNonDefaultSelected(prop, defaultValue) {
        return prop && prop !== defaultValue;
    }

    function setPropWithTracking(dashboardModel, prop, newValue) {
        const newProp = {};
        newProp[prop] = newValue;
        dashboardModel.setProps(newProp);

        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.V3ChangedFacebookAdsFilter, {
            propChanged: prop,
            newValue: newValue
        });
    }

    const AdsFilter = RivalIQ.views.ItemView.mixin({
        attributes: {
            style: 'width: 100%;'
        },

        template: '#adNavToolbarSelectorTemplate',

        behaviors: {
            DropdownSelector: {}
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        _setPropWithTracking: function (prop, newValue) {
            const me = this;
            setPropWithTracking(me.dashboardModel, prop, newValue);
        }
    });

    const AdsMultiSelectFilter = RivalIQ.apps.Dashboard.views.MultiSelectDropdown.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        showFilter: _.constant(true),

        applyDropdownState: function () {
            const me = this;

            const selectedIds = me.getCheckboxesState().sort();
            if (_.isEmpty(selectedIds)) {
                setPropWithTracking(me.dashboardModel, me.filterPropName, undefined);
            } else {
                setPropWithTracking(me.dashboardModel, me.filterPropName, selectedIds.join(','));
            }
        },

        getSelectionSummary: function (selectableItems) {
            const me = this;

            const selectedIds = me._getSelectedIds();

            const selectedNames = _(selectableItems)
                .filter(function (item) {
                    return selectedIds[item.id];
                })
                .map('labelName')
                .value();

            let str;
            if (_.isEmpty(selectedNames)) {
                str = me.noSelectionString;
            } else if (selectedNames.length === 2) {
                str = selectedNames.join(' or ');
            } else {
                str = selectedNames.join(', ');
            }

            return str;
        },

        _getSelectedIds: function () {
            const me = this;

            let labels = me.getProp(me.filterPropName) || '';
            if (!_.isString(labels)) {
                labels = labels.toString();
            }
            const selectedLabels = labels.split(',');

            return _.keyBy(selectedLabels);
        }
    });

    const CampaignObjectiveFilter = AdsMultiSelectFilter.extend({

        getLabelName: _.constant('Objective'),
        filterPropName: 'campaignObjective',
        noSelectionString: 'All',
        getSelectableItems: function () {
            const me = this;

            const selectedIds = me._getSelectedIds();

            return _.map(RivalIQ.enums.facebookAdCampaignObjectives, function (objective) {
                const html = $.tagHtml('span', {
                    class: ['tag-name'],
                    text: objective.name
                });

                return {
                    id: objective.id,
                    labelName: html,
                    selected: selectedIds[objective.id]
                };
            });
        }
    });


    const CampaignAdLabelFilter = AdsMultiSelectFilter.extend({

        getLabelName: _.constant('Label'),
        filterPropName: 'campaignAdLabel',
        noSelectionString: '(No Label Filter)',

        getSelectableItems: function () {
            const me = this;

            const selectedIds = me._getSelectedIds();

            return _.map(me.adLabels, function (adLabel) {
                const html = $.tagHtml('span', {
                    class: ['tag-name'],
                    text: adLabel.name
                });

                return {
                    id: adLabel.id,
                    labelName: html,
                    selected: selectedIds[adLabel.id]
                };
            });
        },

        loadData: function () {
            const me = this;

            const fetchAttrs = {
                adAccountId: me.getProp('adAccountId')
            };

            return RivalIQ.apps.AdsInsights.data.adLabels.fetch(fetchAttrs)
                .then(function (adLabels) {
                    me.adLabels = _.sortBy(adLabels, 'name');
                });
        }
    });

    const CampaignDeliveryStatusFilter = AdsMultiSelectFilter.extend({

        getLabelName: _.constant('Campaign Status'),
        filterPropName: 'campaignDeliveryStatus',
        noSelectionString: 'All',
        getSelectableItems: function () {
            const me = this;

            const selectedIds = me._getSelectedIds();

            return _.map(RivalIQ.enums.facebookAdDeliveryStatuses, function (deliveryStatus) {
                const html = $.tagHtml('span', {
                    class: ['tag-name'],
                    text: deliveryStatus.name
                });

                return {
                    id: deliveryStatus.id,
                    labelName: html,
                    selected: selectedIds[deliveryStatus.id]
                };
            });
        }
    });

    const AdSetDeliveryStatusFilter = AdsMultiSelectFilter.extend({

        getLabelName: _.constant('Ad Set Status'),
        filterPropName: 'adsetDeliveryStatus',
        noSelectionString: 'All',
        getSelectableItems: function () {
            const me = this;

            const selectedIds = me._getSelectedIds();

            return _.map(RivalIQ.enums.facebookAdSetDeliveryStatuses, function (deliveryStatus) {
                const html = $.tagHtml('span', {
                    class: ['tag-name'],
                    text: deliveryStatus.name
                });

                return {
                    id: deliveryStatus.id,
                    labelName: html,
                    selected: selectedIds[deliveryStatus.id]
                };
            });
        }
    });

    const BoostedPostFilter = AdsFilter.extend({
        serializeData: function () {
            const me = this;
            return {
                label: 'Boosted Post',
                selectableItems: _.values(RivalIQ.enums.facebookAdBoostedPostFilters),
                highlighted: isNonDefaultSelected(me.getProp('boostedPostFilter'), RivalIQ.enums.facebookAdBoostedPostFilters.INCLUDE_ALL.id)
            };
        },

        defaultSelector: function () {
            const me = this;
            const selectedItem = me.getProp('boostedPostFilter') || RivalIQ.enums.facebookAdBoostedPostFilters.INCLUDE_ALL.id;
            return `[data-item-id="${selectedItem}"]`;
        },

        onSelectDropdown: function (data) {
            const me = this;

            me._setPropWithTracking('boostedPostFilter', data.itemId);
        }
    });

    views.NavToolbarView = RivalIQ.views.LayoutView.mixin({
        tagName: 'ul',
        className: 'list-inline list-flex',

        template: '#adsNavToolbarTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        regions: {
            campaignAdLabel: '.x-campaign-ad-label-filter',
            campaignObjective: '.x-campaign-objective-filter',
            campaignDeliveryStatus: '.x-campaign-status-filter',
            adsetDeliveryStatus: '.x-adset-status-filter',
            boostedPostFilter: '.x-boosted-post-filter'
        },

        dashboardModelEvents: {
            'change': 'render'
        },

        onRender: function () {
            const me = this;

            me.showCampaignFilters();
            me.showBoostedPostFilter();

            if (me.getProp('exploreLevel') !== RivalIQ.enums.facebookAdObjectTypes.AD) {
                me.adsetDeliveryStatus.show(new AdSetDeliveryStatusFilter({
                    dashboardModel: me.dashboardModel
                }));
            }

            // NOTE these are purely to work around the single selector case
            // given behavior of flexbox (i.e., we don't want the selector to
            // stretch the width of the toolbar). see #12944
            me.$el.toggleClass('constrain', !me.isFocusOnAdAccount());
            me.$('li:empty').addClass('empty');
        },

        getFocusAdObjectId: function () {
            const me = this;
            return me.getProp('adObjectId');
        },

        getAdAccountId: function () {
            const me = this;
            return me.getProp('adAccountId');
        },

        isFocusOnAdAccount: function () {
            const me = this;
            return me.getFocusAdObjectId() === me.getAdAccountId();
        },

        showCampaignFilters: function () {
            const me = this;

            // only show at top level (when looking at an ad account)
            if (me.isFocusOnAdAccount()) {
                me.campaignAdLabel.show(new CampaignAdLabelFilter({
                    dashboardModel: me.dashboardModel
                }));

                me.campaignObjective.show(new CampaignObjectiveFilter({
                    dashboardModel: me.dashboardModel
                }));

                me.campaignDeliveryStatus.show(new CampaignDeliveryStatusFilter({
                    dashboardModel: me.dashboardModel
                }));
            }
        },

        showBoostedPostFilter: function () {
            const me = this;
            me.boostedPostFilter.show(new BoostedPostFilter({
                dashboardModel: me.dashboardModel
            }));
        }
    });

});
